import { LightningBoltIcon } from "@heroicons/react/outline";
import { CodeIcon } from "@heroicons/react/solid";

interface InboxActionButtonPreviewProps {
  buttonLabel: string;
  buttonType?: string;
}

export default function InboxActionButtonPreview({
  buttonLabel,
  buttonType,
}: InboxActionButtonPreviewProps) {
  return (
    <button
      type="button"
      className={`inline-flex w-full items-center justify-center px-4 py-3 border border-gray-300 shadow-sm text-sm leading-4 font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500`}
    >
      {buttonType &&
        (buttonType === "HTTP" ? (
          <CodeIcon className="mr-2 h-5 w-5" />
        ) : (
          <LightningBoltIcon className="mr-2 h-5 w-5" />
        ))}
      {buttonLabel}
    </button>
  );
}
